import React from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  useColorModeValue,
  Icon,
  Badge,
} from "@chakra-ui/react";
import { MdAdd, MdSmartToy } from "react-icons/md";

interface ChatHeaderProps {
  onNewConversation: () => void;
  isLoading?: boolean;
  conversationId?: string | null;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  onNewConversation,
  isLoading = false,
  conversationId = null,
}) => {
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const textColor = useColorModeValue("gray.800", "white");

  return (
    <Box
      bg={bgColor}
      borderBottom="1px solid"
      borderLeft="1px solid"
      borderRight="1px solid"
      borderTop="1px solid"
      borderColor={borderColor}
      borderTopRightRadius="lg"
      borderTopLeftRadius="lg"
      p={4}
    >
      <Flex justify="space-between" align="center">
        <Flex align="center" gap={3}>
          <Icon as={MdSmartToy} boxSize={6} color="blue.500" />
          <Box>
            <Text fontSize="lg" fontWeight="bold" color={textColor}>
              Max AI
            </Text>
            {conversationId && (
              <Text fontSize="xs" color="gray.500" noOfLines={1}>
                Conversation: {conversationId}
              </Text>
            )}
          </Box>
          <Badge
            colorScheme="blue"
            variant="outline"
            fontSize="xs"
            fontWeight="medium"
            borderRadius="full"
            px={2}
            textTransform="inherit"
          >
            Beta Version
          </Badge>
        </Flex>

        <Button
          leftIcon={<MdAdd />}
          onClick={onNewConversation}
          disabled={isLoading}
          size="sm"
          colorScheme="blue"
          variant="outline"
          _hover={{
            bg: useColorModeValue("blue.50", "blue.900"),
          }}
        >
          New Chat
        </Button>
      </Flex>
    </Box>
  );
};

export default ChatHeader;
